import { graphql } from '~/graphql/generated/gql';

export const fetchReferralsData = graphql(`
  query fetchReferralsData($withBalance: Boolean!, $withRefereeBonus: Boolean! = false) {
    # Referee-side only: RewardsViewV1 and ReferralPaymentView share this document and render none
    # of it, and both fields are expensive — a referrer eager-load and a coin aggregate.
    core @include(if: $withRefereeBonus) {
      user {
        self {
          id
          referrerFirstName
          refereeBonus {
            isQualified
            coinsEarned
          }
        }
      }
    }
    getReferralBalance @include(if: $withBalance) {
      availableBalance
      earnedBalance
      pendingRedemptionsBalance
    }
    getReferralCode {
      isQualified
      referralCode {
        code
        expiresAt
        id
        userId
      }
      hasMaxReferrals
      referralsUsed
      maxReferrals
      referrals {
        status
        refereeEmail
        coinsEarned
        signedUpAt
        coinsToQualify
        refereeAvatarIllustration
        refereeAvatarColor
      }
    }
  }
`);

export const sendReferralInvitesMutation = graphql(`
  mutation sendReferralInvites($input: SendReferralInvitesInput!) {
    sendReferralInvites(input: $input)
  }
`);

export const requestReferralPayoutMutation = graphql(`
  mutation requestReferralPayout($input: RequestPayoutInput!) {
    requestReferralPayout(input: $input) {
      earnedBalance
      pendingRedemptionsBalance
      availableBalance
    }
  }
`);
